import { makeAutoObservable } from 'mobx'

import { RootStore } from 'Portals/Customer/stores'

import { ManifestTable } from './ManifestTable'

export class ManifestStore {
	table: ManifestTable

	constructor(public rootStore: RootStore) {
		this.table = new ManifestTable(rootStore)
		makeAutoObservable(this, {}, { autoBind: true })
	}
}
